import service from './request'

/**
 * 获取红名单列表
 */
export const getRedbookList = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/cc/redbook/getList',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 获取有效红名单列表
 */
export const getValidList = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/cc/redbook/getValidList',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 获取红名单信息
 */
export const getRedbookInfo = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/cc/redbook/getInfo',
    method: 'post',
    // type: 'body',
    params: data
  })
}

/**
 * 红名单添加
 */
export const addRedbookInfo = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/cc/redbook/addInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 红名单修改
 */
export const updateRedbookInfo = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/cc/redbook/updateInfo',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 红名单状态修改
 */
export const changeRedbookState = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/cc/redbook/changeState',
    method: 'post',
    type: 'body',
    data
  })
}

/**
 * 红名单删除
 */
export const delRedbookInfo = data => {
  return service({
    showLoading: false,//调用预加载
    url: '/cc/redbook/delInfo',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/http/RedbookManagement.js